import { render, staticRenderFns } from "./RemoveUserModal.vue?vue&type=template&id=edcdac84&lang=pug"
import script from "./RemoveUserModal.vue?vue&type=script&lang=js"
export * from "./RemoveUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports